import React from "react";
import VaporIconBase from "../VaporIconBase";
import { VaporIconBaseType } from "../VaporIconBase";
import { faCirclePlus } from "@fortawesome/pro-regular-svg-icons/faCirclePlus";

export const CirclePlus = (props: VaporIconBaseType) => (
  <VaporIconBase {...props} icon={faCirclePlus}></VaporIconBase>
);
